(function () {
    const $ = require('jquery');
    const Vue = require('vue').default;

    const attorneysFee = require('./attorneys-fee');
    const deedsOfficeFeeForBond = require('./deeds-office-fee-for-bond');
    const deedsOfficeFeeForTransfer = require('./deeds-office-fee-for-transfer');
    const fmt = require('./format-rands');
    const transferDuty = require('./transfer-duty');
    const $form = $('#bond-calculator');

    if ($('#bond-calculator').length == 0) {
        return;
    }

    const calculator = new Vue({
        el: '#bond-calculator',
        data: {
            inline: $form.find('[name="inline"]').val() === 'true',
            purchasePrice: $form.find('[name="price"]').val(),
            deposit: $form.find('[name="deposit"]').val(),
            loanTerm: 20,
            interestRate: 11.25,
            extra: null,
            formattedMonthlyPayments: '',
        },
        computed: {
            extraFloat: function () {
                return parseFloat(this.extra);
            },
            months: function () {
                return this.loanTerm * 12;
            },
            monthlyInterest: function () {
                return (this.interestRate / 100) / 12;
            },
            bondAmount: function () {
                return this.purchasePrice - this.deposit;
            },
            monthlyRepayments: function () {
                return this.bondAmount * (this.monthlyInterest / (1-Math.pow(1+this.monthlyInterest, this.months*-1)));
            },
            formattedMonthlyRepayments: function () {
                if (Number.isNaN(this.monthlyRepayments)) {
                    return fmt(0);
                }

                if (this.inline) {
                    return fmt(this.monthlyRepayments) + '*';
                }

                return fmt(this.monthlyRepayments);
            },
            newLoanTermMonths: function () {
                return Math.log(Math.pow((1-((this.bondAmount * this.monthlyInterest) / (this.monthlyRepayments + this.extraFloat))), -1)) / Math.log(1+this.monthlyInterest);
            },
            newLoanTerm: function () {
                const years = Math.floor(this.newLoanTermMonths / 12);
                const months = Math.floor((this.newLoanTermMonths / 12 - years) * 12);
                return `${years} years, ${months} months`;
            },
            totalPayments: function () {
                return this.monthlyRepayments * this.months;
            },
            savings: function () {
                const totalPaymentsInclExtra = this.newLoanTermMonths * (this.monthlyRepayments + this.extraFloat);
                return fmt(this.totalPayments - totalPaymentsInclExtra);
            },
            showExtraRepayments: function () {
                return this.extra != null && this.extra != '';
            },
            deedsOfficeFeeForBond: function () {
                return deedsOfficeFeeForBond(this.bondAmount);
            },
            deedsOfficeFeeForTransfer: function () {
                return deedsOfficeFeeForTransfer(this.purchasePrice);
            },
            attorneysFeeForTransfer: function () {
                return attorneysFee(this.purchasePrice);
            },
            attorneysFeeForBond: function () {
                return attorneysFee(this.bondAmount);
            },
            postAndPetties: function () {
                return 1100;
            },
            electronicFacilitationCosts: function () {
                return 195;
            },
            deedsOfficeSearchFee: function () {
                return 180;
            },
            VATForBond: function () {
                return (this.attorneysFeeForBond + this.postAndPetties + this.electronicFacilitationCosts + this.deedsOfficeSearchFee) * 0.15;
            },
            VATForTransfer: function () {
                return (this.attorneysFeeForTransfer + this.postAndPetties + this.electronicFacilitationCosts + this.deedsOfficeSearchFee) * 0.15;
            },
            bankInitiationFee: function () {
                return 6037.50;
            },
            bondCost: function () {
                if (!this.purchasePrice) {
                    return 0;
                }

                return this.deedsOfficeFeeForBond
                    + this.attorneysFeeForBond
                    + this.postAndPetties
                    + this.electronicFacilitationCosts
                    + this.deedsOfficeSearchFee
                    + this.VATForBond
                    + this.bankInitiationFee
                ;
            },
            formattedBondCost: function () {
                return fmt(this.bondCost);
            },
            transferDuty: function () {
                return transferDuty(this.purchasePrice);
            },
            transferCost: function () {
                if (!this.purchasePrice) {
                    return 0;
                }

                return this.transferDuty
                    + this.deedsOfficeFeeForTransfer
                    + this.attorneysFeeForTransfer
                    + this.postAndPetties
                    + this.electronicFacilitationCosts
                    + this.deedsOfficeSearchFee
                    + this.VATForTransfer
                ;
            },
            formattedTransferCost: function () {
                return fmt(this.transferCost);
            },
            total: function () {
                return fmt(this.bondCost + this.transferCost);
            },
        },
    });
})();
